import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconNewspaper2"><Path d="M11.5 7.5C11.5 5.567 9.933 4 8 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H8.723C9.32354 20 9.89687 20.1447 10.3863 20.4472C10.8538 20.7361 11.2373 21.1414 11.5 21.6226V7.5Z" fill="currentColor"/><Path d="M12.5 21.6226C12.7627 21.1414 13.1462 20.7361 13.6137 20.4472C14.1031 20.1447 14.6765 20 15.277 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4H16C14.067 4 12.5 5.567 12.5 7.5V21.6226Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper2;
